import React, { useEffect, useRef, useState } from "react";
import { WebRTCPlayer } from "@eyevinn/webrtc-player";

const WHEPPlayer = ({ channelUrl, change, reload, setReload }) => {
  const videoRef = useRef(null); // Reference to the <video> element
  const playerRef = useRef(null); // Reference to WebRTCPlayer instance
  const [internalReload, setInternalReload] = useState(0);
  const reconnectTimeoutRef = useRef(null);
  const isReconnectingRef = useRef(false);

  useEffect(() => {
    const videoElement = videoRef.current;

    if (!channelUrl || !videoElement) return;

    // Khởi tạo WebRTCPlayer instance mới
    const player = new WebRTCPlayer({
      video: videoElement,
      type: "whep",
      timeoutThreshold: 60000,
      statsTypeFilter: "^candidate-*|^inbound-rtp",
    });
    playerRef.current = player;

    const whepUrl = channelUrl.endsWith("/whep")
      ? channelUrl
      : `${channelUrl}/whep`;

    player
      .load(new URL(whepUrl))
      .then(() => {
        isReconnectingRef.current = false;
      })
      .catch((error) => {
        // Silent error
      });

    // Hàm thực hiện reconnect an toàn khi có lỗi hoặc mất kết nối
    const scheduleReconnect = () => {
      if (isReconnectingRef.current) return;
      isReconnectingRef.current = true;

      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }

      // Giữ frame hiện tại và tái kết nối sau 2 giây
      reconnectTimeoutRef.current = setTimeout(() => {
        setInternalReload((prev) => prev + 1);
      }, 2000);
    };

    // Khi phát hiện mất media quá hạn
    player.on("no-media", () => {
      scheduleReconnect();
    });

    // Khi luồng tự phục hồi lại bình thường
    player.on("media-recovered", () => {
      isReconnectingRef.current = false;
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
        reconnectTimeoutRef.current = null;
      }
    });

    // Bắt thêm lỗi connection failed khi server mediamtx đóng hoặc trả về 404
    player.on("initial-connection-failed", () => {
      scheduleReconnect();
    });

    player.on("peer-connection-failed", () => {
      scheduleReconnect();
    });

    player.on("connect-error", () => {
      scheduleReconnect();
    });

    // Dọn dẹp player phiên cũ khi unmount hoặc khi internalReload thay đổi
    return () => {
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
        reconnectTimeoutRef.current = null;
      }
      if (playerRef.current) {
        try {
          playerRef.current.destroy();
        } catch (e) {
          // Silent cleanup error
        }
        playerRef.current = null;
      }
    };
  }, [channelUrl, reload, internalReload]);

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      <video
        ref={videoRef}
        style={{
          width: "100%",
          objectFit: "fill",
          backgroundColor: "#1a1a1a",
          aspectRatio: "16/9",
          display: "block",
          height: "100%",
        }}
        autoPlay
        muted
        playsInline
      />
    </div>
  );
};

export default WHEPPlayer;
